<template>
  <div class="top">
    <!-- 头部按钮和logo -->
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      :default-active="route"
      router
    >
      <el-menu-item index="/home">
        <template slot="title">
          <el-image
            :src="require('@/common/imgs/logo.png')"
            fit="cover"
            class="logo"
          ></el-image>
        </template>
      </el-menu-item>
    </el-menu>

    <!-- 轮播图 -->
    <el-carousel
      :height="height + 'px'"
      class="carousels"
      :arrow="arrow"
      :indicator-position="position"
    >
      <el-carousel-item
        v-for="(item, index) in images"
        :key="index"
        :style="{
          'background-image': 'url(' + item.url + ')',
          'background-size': '100% 100%',
        }"
        class="carousel"
      >
        <div class="gary-cls" @click="handleLink(item.path)">
          <div class="font-cls" v-show="route == '/home'">
            <div class="top-size">{{ item.content1 }}</div>
            <div class="bottom-size">{{ item.content2 }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        {
          url: require('@/common/imgs/swiper1.jpg'),
          content1: "我们事业就是让你享受游戏的快乐。",
          content2: "登游科技作为中国游戏行业中的新兴力量，致力与开发“让玩家获得简单快乐”的经典游戏。",
          path:'https://cdn.dengyou.net/cocos-ball-mage-client/web-mobile-qiniu-temp2/index.html'
        },
        {
          url: require('@/common/imgs/swiper2.jpg'),
          content1: "用心服务 体验至上",
        },
        {
          url: require('@/common/imgs/swiper3.jpg'),
          content1: "释放创意 创造快乐",
          
        },
      ],
      activeIndex: "/home",
    };
  },
  props: {
    height: Number,
    route: String,
    arrow: String,
    position: String,
  },
  created() {},
  methods:{
    handleLink(path){
      if(path){
        window.open(path, "_blank");
      }
    }
  }
};
</script>

<style   src='../css/rotaion.css'>
</style>